module.exports = __webpack_public_path__ + "static/media/Collab@3x.56186af8.png";